<template>
	<div>
		<!-- Wechat -->
		<template  v-if="itemData.displayMode === 'wechat'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnDescribe + '：'">
				<el-input v-model="customerForm[itemData.columnKey]" size="small" disabled style="width:calc(100% - 35px);margin-right: 7px"></el-input>
				<svg-icon :style="{'cursor': customerForm[itemData.columnKey] ? '' : 'not-allowed'}" @click.stop="handleWeiXinLY(itemData.columnKey, customerForm[itemData.columnKey])" icon-class="WXLY" />
			</el-form-item>
		</template>
		<!-- 输入框 -->
		<template  v-if="itemData.displayMode === 'input'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请输入'}
			]">
				<el-input v-model="customerForm[itemData.columnKey]" :disabled="sourceType === 'historyInfo'" maxlength="80" show-word-limit placeholder="请输入" size="small" clearable></el-input>
			</el-form-item>
		</template>
		<!-- 长文本输入 -->
		<template  v-if="itemData.displayMode === 'text'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请输入'}
			]">
				<el-input v-model="customerForm[itemData.columnKey]" :disabled="sourceType === 'historyInfo'" maxlength="600" show-word-limit placeholder="请输入" resize="none" type="textarea" size="small" clearable></el-input>
			</el-form-item>
		</template>

		<!-- 下拉框 -->
		<template  v-if="itemData.displayMode === 'droplist'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请选择'}
			]">
				<el-select v-model="customerForm[itemData.columnKey]" :disabled="sourceType === 'historyInfo'" placeholder="请选择" size="small" filterable clearable>
					<el-option v-for="(item, index) in JSON.parse(itemData.optionsJson)['data']" :key="index" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
		</template>

		<!-- 单选按钮 -->
		<template  v-if="itemData.displayMode === 'radio'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请选择'}
			]">
				<el-radio-group v-model="customerForm[itemData.columnKey]" :disabled="sourceType === 'historyInfo'">
					<el-radio v-for="(item, index) in JSON.parse(itemData.optionsJson)['data']" :key="index" :label="item.value">{{item.label}}</el-radio>
				</el-radio-group>
			</el-form-item>
		</template>

		<!-- 多选按钮 -->
		<template  v-if="itemData.displayMode === 'checkbox'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请选择'}
			]">
				<el-checkbox-group v-model="customerForm[itemData.columnKey]" :disabled="sourceType === 'historyInfo'">
					<el-checkbox v-for="(item, index) in JSON.parse(itemData.optionsJson)['data']" :key="index" :label="item.value">{{item.label}}</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
		</template>

		<!-- 日期 -->
		<template  v-if="itemData.displayMode === 'date'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请选择'}
			]">
				<el-date-picker v-model="customerForm[itemData.columnKey]" :disabled="sourceType === 'historyInfo'" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" size="small"></el-date-picker>
			</el-form-item>
		</template>

		<!-- 时间 -->
		<template  v-if="itemData.displayMode === 'time'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请选择'}
			]">
				<el-time-picker v-model="customerForm[itemData.columnKey]" :disabled="sourceType === 'historyInfo'" value-format="HH:mm:ss" placeholder="选择时间" size="small"></el-time-picker>
			</el-form-item>
		</template>

		<!-- 日期时间 -->
		<template  v-if="itemData.displayMode === 'datetime'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请选择'}
			]">
				<el-date-picker v-model="customerForm[itemData.columnKey]" :disabled="sourceType === 'historyInfo'" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"  placeholder="选择日期时间" size="small"></el-date-picker>
			</el-form-item>
		</template>

		<!-- 数值 -->
		<template  v-if="itemData.displayMode === 'numerical'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请输入'}
			]">
				<el-input v-model="customerForm[itemData.columnKey]" :disabled="sourceType === 'historyInfo'" placeholder="请输入" type="number" size="small" clearable></el-input>
			</el-form-item>
		</template>

		<!-- 正整数 -->
		<template  v-if="itemData.displayMode === 'integer'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请输入'}
			]">
				<el-input-number v-model="customerForm[itemData.columnKey]" :disabled="sourceType === 'historyInfo'" size="small" :min="1" step-strictly></el-input-number>
			</el-form-item>
		</template>

		<!-- 链接 -->
		<template  v-if="itemData.displayMode === 'link'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请输入'}
			]">
				<el-input v-model="customerForm[itemData.columnKey]" :disabled="sourceType === 'historyInfo'" placeholder="请输入" size="small" clearable></el-input>
			</el-form-item>
		</template>

		<!-- 级联选择器 -->
		<template  v-if="itemData.displayMode === 'cascade'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请选择'}
			]">
				<el-cascader v-model="customerForm[itemData.columnKey]" ref="myCascader" @change="(ev) => {return onProvincesChange(ev, itemData)}" :disabled="sourceType === 'historyInfo'" size="small" :props="$$(JSON.parse(itemData.optionsJson), 'props') || {}" placeholder="请选择" :options="getTreeData($$(JSON.parse(itemData.optionsJson), 'data')) || []" filterable></el-cascader>
			</el-form-item>
		</template>

		<!-- 附件 -->
		<template  v-if="itemData.displayMode === 'file'">
			<el-form-item :prop="itemData.columnKey" :label="itemData.columnName + '：'" :rules="[
				{required: itemData.columnNotNull === 'Y', trigger: 'blur', message: '请选择'}
			]">
				<el-upload
					action=""
					drag
					:disabled="sourceType === 'historyInfo'"
					:http-request="(res) => { return httpRequestFile(res, itemData.columnKey)}"
					:show-file-list="false"
					accept="
						image/png, 
						image/jpg, 
						image/jpeg, 
						image/bmp, 
						image/PNG, 
						image/JPG, 
						image/JPEG, 
						image/BMP,
						.PDF
						.pdf,
						.rar,
						.zip,
						.xls,
						.xlsx,
						.docx,
						.doc">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
				<el-button :disabled="sourceType === 'historyInfo'" style="margin-left: 10px;" size="mini" @click.stop="handleView(customerForm[itemData.columnKey])" v-show="customerForm[itemData.columnKey]" type="text">点击查看</el-button>
			</el-form-item>
		</template>
	</div>
</template>

<script>
export default {
	name: "ComponentLibrary",
	props: ['itemData', 'customerForm', 'sourceType'],
	data() {
		return {
			dialogVisible: true,
			nameObj: {}
		}
	},
	methods: {
		onProvincesChange(casIdVal, obj) {
			const casLabelVal = this.$refs['myCascader'].getCheckedNodes()[0].pathLabels;
			this.nameObj[obj.columnKey + '_name'] = casLabelVal;
			this.$emit('emitMyCascader', this.nameObj);
		},
		handleWeiXinLY(appId, openId) {
			if(openId) {
				this.$emit('emitWeiXinLy', appId, openId);
			}
		},
		httpRequestFile(file, key){
			if((file?.file?.size / 1024 / 1024) > 20) {
				this.$message.error('附件大于20M，请重新上传');
				return;
			}
			const formData = new FormData();
			formData.append("brand", this.$store.getters.userInfo.brandIdentify);
			formData.append("servicename", 'customer');
			formData.append('file', file.file);
			this.$api.apiPostUploadFile(formData).then(response => {
				if(response.errcode != 0) return;
				this.customerForm[key] = response.data?.urlMark;
				this.$message('上传成功');
			});
		},
		handleView(url) {
			window.open(url);
		},
		getTreeData(data){
			for(var i=0;i<data.length;i++){
				if(data[i]?.children) {
					if(data[i].children.length<1){
						data[i].children=undefined;
					} else {
						this.getTreeData(data[i].children);
					}
				}
			}
			return data;
		}
	}
}
</script>